import GroupsEditor from './GroupsEditor';
import GroupsGenerateModal from './GroupsGenerateModal';
import generateGroups from './generateGroups';
import { Button, Header, Icon, Message } from '../../components';
import {
  contestsSelector,
  entriesSelector,
  groupsSelector,
} from '../../orm/selectors';
import { bickActions } from '../../common';
import ormActions from '../../orm/actions';

import React from 'react';
import { connect } from 'react-redux';
import { filter, map, uniq } from 'lodash';

const buttonStyle = { width: '12em' };

// TODO: Add quick option to Schedule to do just A groups
// TODO: Embed group generation dialog.
// FIXME: Warning about duplicate assignments!

const Groups = ({ contests, entries, groups, actions }) => {
  const onGroupsGenerate = ({ groupSizeA, groupSizeB, groupSizeOther }) => {
    const groupSizes = [
      Number(groupSizeA) || 18,
      Number(groupSizeB) || 18,
      Number(groupSizeOther) || 18,
    ];

    const groups = generateGroups(contests, entries, { groupSizes });

    for (const group of groups) actions.group.upsert(group);
  };

  const onGroupsClear = () => actions.group.resetAll([]);

  const entriesMissingGroups = filter(entries, entry => !entry.group);
  const contestsMissingGroups = uniq(
    map(entriesMissingGroups, 'contest.title'),
  );

  return (
    <section>
      <Header as="h1">Groups</Header>
      <p>
        {!entriesMissingGroups.length && (
          <Icon key={1} name="checkmark" color="green" />
        )}
        {entriesMissingGroups.length === entries.length
          ? 'Entries have not been divided into groups yet.'
          : 'Entries have been divided into groups.'}
      </p>
      {![entries.length, 0].includes(entriesMissingGroups.length) && (
        <Message
          icon="warning circle"
          header="Entries are missing division into groups!"
          content={[
            entriesMissingGroups.length,
            ' entries from contests: ',
            contestsMissingGroups.join(', '),
          ]}
          warning
        />
      )}
      <p>
        <GroupsGenerateModal
          id="schedule--groups-generate"
          trigger={
            <Button
              content="Generate groups"
              disabled={!entriesMissingGroups.length}
              positive
              style={buttonStyle}
            />
          }
          meta={{ contests, entries }}
          onGenerate={onGroupsGenerate}
        />
        <Button
          disabled={!groups.length}
          icon="warning sign"
          content="Clear groups"
          onClick={onGroupsClear}
          negative
          style={buttonStyle}
        />
      </p>
      <GroupsEditor
        id="schedule--groups-editor"
        //locked={true}
        groups={groups}
        actions={actions.group}
        meta={{ contests, entries, groups }}
      />
    </section>
  );
};

const mapStateToProps = ({ orm }) => ({
  contests: contestsSelector(orm),
  entries: entriesSelector(orm),
  groups: groupsSelector(orm),
});

const mapDispatchToProps = dispatch => ({
  actions: bickActions(ormActions, ['group'], dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Groups);



// WEBPACK FOOTER //
// ./src/pages/Schedule/Groups.js